export default {
  cookbook: {
    replaceIngredient: {
      __typename: 'BasicMutationSuccess',
      code: 200,
    },
  },
};
